/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskLiveChatType from '@jira/spa-apps__project-settings-service-desk-live-chat/src/ServiceDeskLiveChatSpa.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskLiveChat: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProjectSettingsServiceDeskLiveChatType>(
		() =>
			import(
				/* webpackChunkName: "async-project-settings-service-desk-live-chat", jiraSpaEntry: "async-project-settings-service-desk-live-chat" */ '@jira/spa-apps__project-settings-service-desk-live-chat/src/ServiceDeskLiveChatSpa.tsx'
			),
	);

const AsyncProjectSettingsServiceDeskLiveChat = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskLiveChat}
		pageId="project-settings-live-chat"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskLiveChat;
